import Vue from 'vue';
import App from './App';

import VueAMap from 'vue-amap';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/bootstrap/css/bootstrap.min.css';
import './assets/bootstrap/js/bootstrap.min.js';
import './assets/bootstrapCarouse/css/style.css';
import animated from 'animate.css';
import router from './router';
Vue.use(ElementUI);
Vue.use(animated);

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
});



// WEBPACK FOOTER //
// ./src/main.js